import { ThemeSlice } from '@/store/slices/theme/types';

// Map of available theme style entry points discovered at build-time.
const themeStyleModules = import.meta.glob('../styles/**/index.scss');

// Track loaded themes to avoid redundant imports.
const loaded = new Set<string>();

export async function loadThemeStyles(
  theme: ThemeSlice['theme'] | string,
): Promise<void> {
  const key = `../styles/themes/${theme}/index.scss`;
  const loader = themeStyleModules[key];
  if (!loader) {
    // No style module found for this theme; fail loudly to catch misconfigurations
    throw new Error(`Theme styles not found at ${key}`);
  }
  // Always load the theme, even if it was previously loaded
  // This ensures that theme styles are always applied when switching themes
  await loader();
  loaded.add(key);
}
